import React, { cloneElement, useState } from 'react';
import { styled } from '@mui/material';

import Box from 'shell/components/Box';
import Menu from 'shell/components/Menu';
import MenuItem from 'shell/components/MenuItem';

const ALIGN = ['left', 'right'];

const CustomMenuItem = styled(MenuItem)(({ destructive, theme }) => {
    return {
        ...(destructive && {
            color: theme.palette.ensightful.error[500],
        }),
    };
});

export default ({ id, align = 'right', options, rootComponent, onSelect }) => {
    if (!id) throw new Error('Shell: Missing id in component Dropdown.');
    if (!ALIGN.includes(align)) throw new Error(`Shell: Invalid align "${align}" in component Dropdown.`);

    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (e) => {
        e.stopPropagation();
        setAnchorEl(e.currentTarget);
        if (rootComponent.props.onClick) rootComponent.props.onClick(e);
    };

    const handleClose = (e, { key, value }) => {
        e.stopPropagation();
        setAnchorEl(null);
        if (key && value) onSelect({ key, value });
    };

    const open = Boolean(anchorEl);

    return (
        <Box>
            {cloneElement(rootComponent, {
                id,
                'aria-controls': open ? `${id}-menu` : undefined,
                'aria-expanded': open ? true : undefined,
                'aria-haspopup': true,
                onClick: handleClick,
            })}
            <Menu
                id={`${id}-menu`}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: align,
                }}
                MenuListProps={{
                    'aria-labelledby': id,
                }}
                open={open}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: align,
                }}
                onClick={(e) => e.stopPropagation()}
                onClose={handleClose}
            >
                {options.map(({ key, value, disabled }) => (
                    <CustomMenuItem
                        key={key}
                        destructive={key === 'delete'}
                        disabled={disabled}
                        onClick={(e) => handleClose(e, { key, value })}
                    >
                        {value}
                    </CustomMenuItem>
                ))}
            </Menu>
        </Box>
    );
};
